/** *****************************************************************************
 * Copyright (c) 2023 Nosto Solutions Ltd All Rights Reserved.
 * <p>
 * This software is the confidential and proprietary information of
 * Nosto Solutions Ltd ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only in
 * accordance with the terms of the agreement you entered into with
 * Nosto Solutions Ltd.
 ***************************************************************************** */
import createRequestBuilder from "@/core/request"
import bus, { Prerender } from "@/core/api/bus"

type ResponseKey = keyof Prerender
type State = "none" | "loading" | "loaded"

let value: Prerender | undefined
let state: State = "none"

bus.on("prerequest", () => {
  if (state === "none") {
    state = "loading"
  }
})

const response = new Promise<Prerender>(resolve => {
  bus.on("prerender", response => {
    value = response
    state = "loaded"
    resolve(response)
  })
})

async function stateFn() {
  switch (state) {
    case "loaded":
      return value!
    case "none":
      void createRequestBuilder().send({
        skipPageViews: true,
        skipEvents: true
      })
    // fallthrough
    case "loading":
      return await response
    default:
      throw new Error("Incorrect state")
  }
}

/**
 * Use ev1 state transformed by a function
 */
export default function ev1state<T>(extractor: (p: Prerender) => T): () => Promise<T>
/**
 * Use single field from ev1 state
 */
export default function ev1state<K extends ResponseKey>(key: K): () => Promise<Prerender[K]>

export default function ev1state(o: ResponseKey | ((p: Prerender) => unknown)) {
  const extractor = typeof o === "function" ? o : (p: Prerender) => p[o]
  return async () => extractor(await stateFn())
}
